import { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import TapIcon from '../../../services/TapIcon';
import { useSelector } from 'react-redux';
import HttpAPICall from '../../../services/HttpAPICall';
import Loader from '../../../components/ui/Loader/Loader';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import DeviceSearchModal from './DeviceSearchModal';
import { DisplaySearchCriteria } from '../../../components/TapUi';
import DeviceData from '../DeviceData';
import DeviceHistory from '../DeviceHistory';
import TripSessionDetail from '../TripSessionDetail';
import ConslidatedTripDetails from '../ConslidatedTripDetails';

const DeviceListing = () => {
    const access_token = useSelector(state => state.auth.access_token);
    const [loading, setLoading] = useState(false);
    const deviceSearchModalRef = useRef(null);
    const [deviceListing, setDeviceListing] = useState([]);
    const [minimizeTable, setMinimizeTable] = useState(false);
    const [FilterForm, setFilterForm] = useState({});
    const [formSearchedElems, setFormSearchedElems] = useState([]);

    const [selectedDeviceId, setSelectedDeviceId] = useState(null);
    const [activeView, setActiveView] = useState('device_detail');

    const fetchDeviceData = () => {
        setLoading(true);
        let params = { FilterForm };
        HttpAPICall.withAthorization('GET', `http://tappetbox.mysolutions.in/api/DeviceAsset`, access_token, params , {}, (resp) => {
            setDeviceListing(resp.data);
        }).then(() => setLoading(false));
    };

    useEffect(() => {
        fetchDeviceData();
    }, [formSearchedElems]);

    const viewDeviceData = (deviceId) => {
        setSelectedDeviceId(deviceId);
        setMinimizeTable(true);
        setActiveView('device_detail');
    };

    const closeViewDetails = () => {
        setMinimizeTable(false);
        setSelectedDeviceId(null);
        setActiveView('device_detail');
    };

    const handleDeviceDataClick = () => {
        setActiveView('device_data');
    };

    const handleDeviceHistoryClick = () => {
        setActiveView('device_history');
    };

    const handleTripDetailsClick = () => {
        setActiveView('trip_details');
    };

    const handleConsolidateTripClick = () => {
        setActiveView('consolidate_trip');
    };

    const searchModalHandle = () => {
        if (deviceSearchModalRef.current) {
            deviceSearchModalRef.current.initModalHandler();
        }
    };

    const submitSearchForm = (searchedElems, assetScsSearchForm) => {
        setFormSearchedElems(searchedElems);
        setFilterForm(assetScsSearchForm);
    };

    const deviceSearchClear = () => {
        setFormSearchedElems([]);
        setFilterForm({});
        deviceSearchModalRef.current.clearSearchForm();
    };

    const renderActiveView = () => {
        const selectedDevice = deviceListing.find(device => device.id === selectedDeviceId);

        switch (activeView) {
            case 'device_data':
                return <DeviceData deviceId={selectedDeviceId} deviceData={selectedDevice} />;
            case 'device_history':
                return <DeviceHistory deviceId={selectedDeviceId} deviceData={selectedDevice} />;
            case 'trip_details':
                return <TripSessionDetail deviceId={selectedDeviceId} deviceData={selectedDevice} />;
            case 'consolidate_trip':
                return <ConslidatedTripDetails deviceId={selectedDeviceId} deviceData={selectedDevice} />;
            case 'device_detail':
            default:
                return deviceViewDetails(selectedDevice);
        }
    };

    const deviceViewDetails = (detail) => {
        return (
            <div className="tab_content_header">
                <div className="tab_content_wrapper"> <span className="content_heading"> Group & Asset details </span></div>
                {detail ? (
                    <>
                        <table className="table table-hover table-bordered table-responsive bg-white my-2 mb-3">
                            <tbody>
                                <tr>
                                    <td style={{ width: "26%" }}>Device ID</td>
                                    <th>IOT-001</th>
                                </tr>
                                <tr>
                                    <td style={{ width: "26%" }}>Device Type</td>
                                    <th>ds</th>
                                </tr>
                                <tr>
                                    <td style={{ width: "26%" }}>Product Manufacturer</td>
                                    <th>{detail.deviceManufacturerName}</th>
                                </tr>
                                <tr>
                                    <td style={{ width: "26%" }}>Product Model</td>
                                    <th>{detail.deviceModel}</th>
                                </tr>
                                <tr>
                                    <td style={{ width: "26%" }}>Product Serial No</td>
                                    <th>1145105027</th>
                                </tr>
                                <tr>
                                    <td style={{ width: "26%" }}>IMEI Number</td>
                                    <th>{detail.deviceIMEI}</th>
                                </tr>
                                <tr>
                                    <td style={{ width: "26%" }}>Group ID</td>
                                    <th>TBIPL</th>
                                </tr>
                                <tr>
                                    <td style={{ width: "26%" }}>Asset Name</td>
                                    <th>Genset Office 15 kva</th>
                                </tr>
                            </tbody>
                        </table>
                    </>
                ) : null}
                <div className="tab_content_wrapper "> <span className="content_heading"> IoT details </span></div>
                <table className="table table-hover table-bordered table-responsive bg-white my-2 mb-3">
                    <tbody>
                        <tr>
                            <td style={{ width: "26%" }}>IOT</td>
                            <th>353691841172736</th>
                        </tr>
                    </tbody>
                </table>
                <div className="tab_content_wrapper "> <span className="content_heading"> SIM details </span></div>
                <table className="table table-hover table-bordered table-responsive bg-white my-2 mb-3">
                    <tbody>
                        <tr>
                            <td style={{ width: "26%" }}>SIM</td>
                            <th>89911025034021446457</th>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    };

    const deviceListingJsx = () => {
        return (
            <>
                <DisplaySearchCriteria searchedElems={formSearchedElems} onClearFilter={deviceSearchClear} />
                <table className="table table-bordered table-fixed bg-white table-sm">
                    <thead className="table-secondary">
                        {minimizeTable ? (
                            <tr>
                                <th scope="col" style={{ width: "8%" }}>Device Listing</th>
                            </tr>
                            
                        ) : (
                            <tr className='text-center'>
                                <th className="text-center" style={{ width: "10%" }}>Device ID</th>
                                <th className="text-center" style={{ width: "10%" }}>Device Type</th>
                                <th className="text-center" style={{ width: "15%" }}>Product Manufacturer</th>
                                <th className="text-center" style={{ width: "12%" }}>Product Model</th>
                                <th className="text-center" style={{ width: "12%" }}>Product Serial No</th>
                                <th className="text-center" style={{ width: "12%" }}>IMEI Number</th>
                                <th className="text-center" style={{ width: "12%" }}>Group ID</th>
                                <th className="text-center" style={{ width: "12%" }}>Asset Name</th>
                            </tr>
                        )}
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr><td colSpan="8"><Loader /></td></tr>
                        ) : (deviceListing.length > 0 ? (
                            deviceListing.map((device, index) => {
                                return (
                                    <tr key={index} className='text-center'>
                                        {minimizeTable ? (
                                            <td style={{ width: "25%" }} className='text-start'>
                                                <div className='d-flex align-items-center justify-content-between'>
                                                    <a
                                                        href="#"
                                                        className="text-capitalize link-primary"
                                                        onClick={() => viewDeviceData(device.id)}
                                                    >
                                                          GPS Device
                                                    </a>
                                                    <p className='mb-0'>{device.deviceIMEI || "-"}</p>
                                                </div>
                                            </td>
                                        ) : (
                                            <>
                                                <td>IOT-001</td>
                                                <td>
                                                    <a
                                                        href="#"
                                                        className="text-capitalize link-primary"
                                                        onClick={() => viewDeviceData(device.id)}
                                                    >
                                                        GPS Device
                                                    </a>
                                                </td>
                                                <td>{device.deviceManufacturerName || "-"}</td>
                                                <td>{device.deviceModel || "-"}</td>
                                                <td>1145105027</td>
                                                <td>{device.deviceIMEI || "-"}</td>
                                                <td>TBIPL</td>
                                                <td>Genset Office 15 kva</td>
                                            </>
                                        )}
                                    </tr>
                                );
                            })
                        ) : (
                            <tr><td colSpan="8" className="text-center">No Records</td></tr>
                        ))}
                    </tbody>
                </table>
            </>
        );
    };

    const deviceJsx = () => {
        return (
            <>
                <div className="page_title row m0">
                    <div className={minimizeTable ? "col-3" : "col-12"}>
                        <h3>Device Listing</h3>
                        {(!minimizeTable) ? (
                            <div className="text-end mt15">
                                <>
                                    <Link to="/add_device">
                                        <button type="button" className="btn btn-primary">Add</button>
                                    </Link>
                                    <button type="button" className="btn btn-secondary" onClick={searchModalHandle}>
                                        <TapIcon.imageIcon icon={TapIcon.SearchIcon} className="img-fluid" alt="item-action" />
                                    </button>
                                </>
                            </div>
                        ) : null}
                    </div>
                    {minimizeTable ? (
                        <div className="col-9 tap_border_left">
                            <div className="d-flex justify-content-between align-items-center">
                                <h3 className="mb-0">
                                    {activeView === 'device_detail' && 'Device Detail'}
                                    {activeView === 'device_data' && 'Device Data'}
                                    {activeView === 'device_history' && 'Device History'}
                                    {activeView === 'trip_details' && 'Trip Details'}
                                    {activeView === 'consolidate_trip' && 'Consolidate Trip Details'}
                                </h3>
                                <div className="text-end mt15">
                                    <span className="dropdown">
                                        <button
                                            type="button"
                                            id='actionMenuButton'
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                            className="btn btn-secondary"
                                        >
                                            <TapIcon.imageIcon icon={TapIcon.ActionIcon} className="img-fluid" alt="item-action" />
                                        </button>
                                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                            <li>
                                                <button
                                                    className='dropdown-item'
                                                    onClick={handleDeviceDataClick}
                                                >
                                                    Device Data
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    className='dropdown-item'
                                                    onClick={handleDeviceHistoryClick}
                                                >
                                                    Device History
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    className='dropdown-item'
                                                    onClick={handleTripDetailsClick}
                                                >
                                                    Trip Details
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    className='dropdown-item'
                                                    onClick={handleConsolidateTripClick}
                                                >
                                                    Consolidate Running
                                                </button>
                                            </li>
                                        </ul>
                                    </span>
                                    <button
                                        type="button"
                                        className="btn btn-secondary ms-2"
                                        onClick={closeViewDetails}
                                    >
                                        <TapIcon.imageIcon icon={TapIcon.CloseIcon} className="img-fluid" alt="item-close" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    ) : null}
                </div>
                <div className="container-fluid pl5">
                    <div className="page_containt row">
                        <div className={['pageTbl', minimizeTable ? 'col-3' : 'col-12'].join(' ')}>
                            {deviceListingJsx()}
                        </div>
                        {minimizeTable ? (
                            <div className="col-9 pr4 pl4">
                                <div className="bg-white p-2" style={{ height: "100%" }}>
                                    {renderActiveView()}
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
            </>
        );
    };

    return (
        <ApplicationLayout>
            <Helmet><title>Device Listing</title></Helmet>
            {deviceJsx()}
            <DeviceSearchModal ref={deviceSearchModalRef} submitSearchFormProp={submitSearchForm} />
        </ApplicationLayout>
    );
};

export default DeviceListing;